"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Placeholder___StyledSvg",
  componentId: "sc-4xcb6q-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Placeholder(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "#f0f",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M345.235 271.421v41.895H135.758V271.42H72.915v-20.947h41.896v-41.895h41.895v-41.895h167.581v41.895h41.895v41.895h41.896v20.947h-62.843zm62.843-62.842v-41.895h-41.896V124.79h-41.895V82.895h-41.895v41.894h-83.79V82.895h-41.896v41.894H114.81v41.895H72.915v41.895H31.02v188.526h41.895v-83.79h20.948v83.79h41.895v-41.894h209.477v41.894h41.895v-83.79h20.948v83.79h41.895V208.58h-41.895zM219.555 397.105h-83.79V439h83.79zM261.45 439h83.791v-41.895H261.45zM366.189 41h-41.896v41.895h41.896zM114.817 82.895h41.895V41h-41.895z"
  }), _react["default"].createElement("path", {
    d: "M156.712 271.421h41.895v-41.895h-41.895zM282.398 271.421h41.895v-41.895h-41.895z"
  })));
}

var _default = Placeholder;
exports["default"] = _default;